import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetProductsAddedToCart = createSlice({
    name: "getProductsAddedToCart",
    initialState,
    reducers: {
        getProductsAddedToCartRequest(state) {
            state.loading = true;
        },
        getProductsAddedToCartRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getProductsAddedToCartRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getProductsAddedToCartRequest,
    getProductsAddedToCartRequestSuccess,
    getProductsAddedToCartRequestError,
} = GetProductsAddedToCart.actions;

export default GetProductsAddedToCart.reducer;
